import { getInventoryArticleType } from '../../getInventoryArticleType';
import { fToCurrency, getArticlePriceData } from '../../index';
import { LivePrice } from '../types';
import { PriceTables } from '@agrantis/cart/types';

interface ItemPriceProps {
  article: any;
  className?: string;
  erpCustomergroupId?: string | null;
  priceTables?: PriceTables | null;
  comparisonAmount?: number | null;
  livePrice?: LivePrice;
}

const ItemPrice = (props: ItemPriceProps) => {
  const {
    article,
    className,
    erpCustomergroupId,
    priceTables,
    livePrice,
    comparisonAmount,
  } = props;

  const itemType = getInventoryArticleType(article);
  const amount = article.amount || 1;

  const { basePrice, finalPrice } = getArticlePriceData({
    item: article,
    livePrice,
    retailerPriceTables: priceTables,
    customerGroupId: erpCustomergroupId,
  });

  const countableDisplayPrice = (finalPrice / amount) * (comparisonAmount || 1);

  if (!basePrice) return null;

  return (
    <div className={className}>
      <p className="text-4-0 md:text-2-0 font-bd" role="finalPrice">
        {fToCurrency(finalPrice || 0)}
      </p>
      <div className="text-2-0 md:text-1-2" role="subPrice">
        {itemType === 'countable' && (
          <p>
            {fToCurrency(countableDisplayPrice)} /{article.unit}
          </p>
        )}
        {itemType === 'loose' && (
          <p>
            / {article.amount} {article.unit}
          </p>
        )}
      </div>
    </div>
  );
};

export default ItemPrice;
